import { Typography } from 'components/_common/Typography';
import React from 'react';

type LocationVulnerabilitySummaryProps = {
  locationResiliency: number;
  locationName: string;
};

const highVulnerabilityThreshold = 39;
const moderateVulnerabilityThreshold = 74;

const LocationVulnerabilitySummary: React.FC<LocationVulnerabilitySummaryProps> = ({
  locationResiliency,
  locationName,
}) => {
  if (locationResiliency === null) {
    return null;
  }
  if (locationResiliency <= highVulnerabilityThreshold) {
    return (
      <div data-testid="location-vulnerability-summary">
        <Typography variant="subtitle1" inline>
          {locationName} has high relative vulnerability
        </Typography>{' '}
        to the potential spread and impact of infectious diseases
      </div>
    );
  }
  if (locationResiliency <= moderateVulnerabilityThreshold) {
    return (
      <div data-testid="location-vulnerability-summary">
        <Typography variant="subtitle1" inline>
          {locationName} has moderate relative vulnerability
        </Typography>{' '}
        to the potential spread and impact of infectious diseases
      </div>
    );
  }

  return null;
};

export default LocationVulnerabilitySummary;
